import React from 'react';
import { PORTAL } from '../../config';

const AuthLayout = (WRC) =>
{
	const NewComponent = () =>
	{
		return (
			<div className='flexCol justifyCntr fullHeight pdngSM authbg'>
				<div className='resRowCol alignCntr '>
					<div className='flexMinWidthCol justifyCntr alignCntr '>
						<img src={PORTAL=='WORLD'?'images/login-prod.png':'images/login.png'} alt='login' className={PORTAL=='WORLD'?'loginImgProd':'loginImg'}/>
					</div>
					<div className='flexInline alignCntr hrLine mrgnHSM' />
					<div className='flexMinWidthCol justifyCntr alignCntr resMrgnTXLG'>
						<WRC />
					</div>
				</div>
			</div>
		);
	};

	return NewComponent;
};

export default AuthLayout;
